export const Beta = ({ color = "black" }: { color?: "black" | "white" }) => {
  const getFillColor = () => {
    if (color === "black") return "fill-[#231F20]";
    if (color === "white") return "fill-[#fff]";
  };

  return (
    <svg
      className={getFillColor()}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
    >
      <path
        d="M138.3,115.6c-2.1-5.5-5.3-10.2-9.3-14.2s-8.8-7.1-14.2-9.3s-11.2-3.3-17.4-3.3c-6,0-11.8,1-17.1,3.1
	C74.9,94,70.2,97,66.1,101c-4.1,4-7.3,8.7-9.5,14.2c-2.3,5.5-3.4,11.4-3.4,17.7s1.2,12.2,3.4,17.7s5.4,10.2,9.5,14.2
	c1.8,1.7,3.7,3.3,5.7,4.7l-1.7,7.8h10.7l0.6-3c5.1,1.8,10.4,2.7,16.1,2.7c6.2,0,12-1.1,17.4-3.3c5.4-2.2,10.2-5.3,14.2-9.3
	c4-4.1,7.1-8.8,9.3-14.2c2.2-5.4,3.3-11.3,3.3-17.5C141.7,126.4,140.6,120.6,138.3,115.6z M129.9,152.5c-3.2,5.8-7.5,10.4-13.2,13.7
	s-12.1,4.9-19.2,4.9c-5.3,0-10.3-0.9-14.8-2.7l2.1-9.6c2.1,1.8,4.9,2.7,8.4,2.7c6.2,0,11.1-1.8,14.7-5.4c3.6-3.6,5.4-8,5.4-13.2
	c0-6.1-3.1-9.7-9.4-10.8l0.1-0.1c9.5-3,14.2-8.2,14.2-15.5c0-6.7-4.8-10.1-14.2-10.1c-6.1,0-11,1.6-14.8,5
	c-3.8,3.3-6.6,9.1-8.4,17.2l-7.5,34c-3.2-2.8-5.9-6.1-8-10.1c-3.1-5.9-4.7-12.5-4.7-19.9c0-7.3,1.5-13.8,4.6-19.7
	c3.1-5.8,7.4-10.4,13.1-13.7c5.7-3.3,12.1-4.9,19.2-4.9s13.5,1.6,19.2,4.9c5.7,3.2,10.1,7.8,13.2,13.7c3,5.9,4.6,12.5,4.6,19.8
	C134.5,140,132.9,146.6,129.9,152.5z M102.7,143.5c0,3.7-1,6.9-3.1,9.8c-2,2.9-4.4,4.3-7.1,4.3c-1.5,0-2.9-0.5-4.2-1.3s-2-2-2-3.4
	c0-0.7,0.1-1.5,0.3-2.4l4.8-21.9c2.8-12.1,6.9-18.2,12.1-18.2c2.9,0,4.3,1.9,4.3,5.7c0,4-1.1,7.3-3.5,9.9c-2.4,2.6-5.2,4-8.6,4.3
	l-0.9,4C100.1,134.4,102.7,137.4,102.7,143.5z"
      />
    </svg>
  );
};
